import { Adapter as r } from "../../../../../adapter.js";
import { LoyaltyProgrammeDesignModel as o } from "./loyaltyProgrammeDesign.model.js";
class t extends r {
  adapt(e) {
    return new o({
      legalUrl: e.legal_url,
      codeType: Number(e.code_type)
    });
  }
  serialize(e) {
  }
}
export {
  t as LoyaltyProgrammeDesignAdapter
};
//# sourceMappingURL=loyaltyProgrammeDesign.adapter.js.map
